import { Box, Button, Menu, MenuItem, Link } from '@mui/material';
import React, { useState } from 'react';
import styled from '@emotion/styled';

const StyledButton = styled(Button)`
  text-transform: none;
  color: white;
  font-family: "PoppinsM";
  width: fit-content;
  border-radius: 40px !important;
  font-size: 14px;
  font-family: Bold !important;
  padding: ${(props) => (props.p ? props.p : "6px 14px")};
  border: 3px solid #220154;
  display: flex;
  align-items: center;
  gap: 6px;
  min-height: auto;

  &:hover {
    background: linear-gradient(90deg, #7300FF 0%, #B892ED 100%);
    color: white;
  }
  
  @media(max-width: 599px) {
    font-size: 12px !important;
    padding: 5px 12px !important;
    gap: 4px;
  }
`;

const UpperBox = styled(Box)`
  background: linear-gradient(90deg, #7300FF 0%, #B892ED 100%);
  padding: 2px;
  border-radius: 40px;
  width: max-content;
`;

const Img = styled.img`
  width: 44px;
  height: 44px;
  object-fit: contain;
  
  @media (max-width: 600px) {
    width: 20px;
    height: 20px;
  }
`;

const TextContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
`;

const ButtonText = styled.span`
  font-size: 16px;
  line-height: 16px;
  font-weight: 600;
  text-align: left;
  white-space: nowrap;
  color: white;

  @media (max-width: 600px) {
    font-size: 12px;
    line-height: 14px;
  }
`;

const StyledMenu = styled(Menu)`
  .MuiPaper-root {
    background: linear-gradient(135deg, #1a0033 0%, #2d0052 100%);
    border: 2px solid #7300FF;
    border-radius: 12px;
    margin-top: 8px;
    box-shadow: 0 8px 32px rgba(115, 0, 255, 0.3);
  }

  .MuiList-root {
    padding: 6px;
  }
`;

const StyledMenuItem = styled(MenuItem)`
  color: white;
  border-radius: 8px;
  margin: 3px 0;
  padding: 8px 12px;
  font-family: "PoppinsM";
  font-size: 13px;
  transition: all 0.3s ease;
  background: rgba(115, 0, 255, 0.1);
  border: 1px solid rgba(115, 0, 255, 0.3);
  min-width: 160px;

  &:hover {
    background: linear-gradient(90deg, #7300FF 0%, #B892ED 100%);
    border-color: #B892ED;
    transform: translateX(4px);
  }

  @media (max-width: 600px) {
    font-size: 12px;
    padding: 7px 10px;
    min-width: 140px;
  }
`;

const PurpleButton = (props) => {
  const { src, name, w, small_w, array, href, target, children, ...restProps } = props;
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    if (href) {
      return;
    }
    if (array && array.length > 0) {
      setAnchorEl(event.currentTarget);
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  // Direct link button
  if (href) {
    return (
      <UpperBox>
        <StyledButton
          component="a"
          href={href}
          target={target}
          {...restProps}
        >
          {children}
        </StyledButton>
      </UpperBox>
    );
  }

  // Dropdown menu button
  if (array && array.length > 0) {
    return (
      <>
        <UpperBox>
          <StyledButton
            id="purple-button"
            aria-controls={open ? 'purple-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
            onClick={handleClick}
            {...restProps}
          >
            {src && <Img src={src} alt={name} />}
            <TextContainer>
              <ButtonText>
                Download For {name}
              </ButtonText>
            </TextContainer>
          </StyledButton>
        </UpperBox>

        <StyledMenu
          id="purple-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            'aria-labelledby': 'purple-button',
          }}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
        >
          {array.map((item, index) => (
            <Link
              href={item.link}
              target={item?.target}
              underline="none"
              key={item.title || index}
            >
              <StyledMenuItem onClick={handleClose}>
                {item.title}
              </StyledMenuItem>
            </Link>
          ))}
        </StyledMenu>
      </>
    );
  }

  // Default button
  return (
    <UpperBox>
      <StyledButton {...restProps}>
        {children}
      </StyledButton>
    </UpperBox>
  );
};

export default PurpleButton;